<template>
  <div class="widget" ref="widgetRef">
    <BriefcaseHeader class="widget__hdr" />
    <template v-if="isLoadingAssets || isLoadingUserData">
      <div class="widget__loader">
        <LoaderCircle :color="'var(--circle-loader)'" :size="32"/>
      </div>
    </template>
    <template v-else>
      <EmptyAssets class="widget__empty-block" v-if="!isCoinSearchOpened && assets.length === 0" />
      <BriefcaseUserList class="widget__list" v-else-if="!isCoinSearchOpened" />
      <SearchModule lass="widget__search" v-if="isCoinSearchOpened"/>
      <BriefcaseActionButtons class="widget__actions" />
    </template>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { onMounted, watch, ref, onUnmounted, nextTick } from 'vue';
  import { useUserAuth } from '@/Groups/Notifications/private/imports/userStoreData';
  import { useBriefcaseState } from '@/Groups/Briefcase/private/composables/computedValues';
  import { useBriefcaseDropdown } from '@/Groups/Briefcase/private/imports/toggleDropdown';
  //--------------------------------
  import BriefcaseActionButtons from '@/Groups/Briefcase/private/core/BriefcaseActionButtons/BriefcaseActionButtons.vue';
  import BriefcaseHeader from '@/Groups/Briefcase/private/core/BriefcaseHeader/BriefcaseHeader.vue';
  import BriefcaseUserList from '@/Groups/Briefcase/private/core/BriefcaseUserList/BriefcaseUserList.vue';
  import SearchModule from '@/Groups/Briefcase/private/core/SearchModule/SearchModule.vue';
  import EmptyAssets from '@/Groups/Briefcase/private/ui/EmptyAssets/EmptyAssets.vue';
  import { LoaderCircle } from '@/Groups/Briefcase/private/imports/externalTemplates'; 
  //--------------------------------
  const store = useStore();
  //--------------------------------
  const { hasPaidAccount, isLoadingUserData } = useUserAuth();
  //--------------------------------
  const { isCoinSearchOpened, isLoadingAssets, assets, isReady } = useBriefcaseState();
  //--------------------------------
  const { close } = useBriefcaseDropdown();
  //--------------------------------
  const widgetRef = ref(null);
  //--------------------------------
  onMounted(async () => {
    await nextTick();
    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);
    if(!hasPaidAccount.value) return;
    if(isReady.value) return;
    store.dispatch('Briefcase/getAssets');
  });
  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
  })
  //--------------------------------
  //Клик вне области
  const handleClickOutside = (event) => {
    const ignoredSelectors = [
      '.actions__add-btn',
      '.actions__add-choosen-btn', 
      '.hdr__arrow-box',
      '.list__remove'
    ];
    if (ignoredSelectors.some(selector => event.target.closest(selector))) return;
    if (widgetRef.value && !widgetRef.value.contains(event.target)) {
      close();
    }
  };
  //--------------------------------
  //Отслеживание изменений hasPaidAccount
  watch(hasPaidAccount, async (newValue) => {
    if (newValue) {
      store.dispatch('Briefcase/getAssets');
    }
  },{ immediate: true });
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>